module.exports = __webpack_public_path__ + "media/images/result_sets/circles/7r8r5n1n-45022027909d1d5e6695164b596e0253.svg";